import { Suspense } from 'react'
import { Route, matchPath, useLocation } from 'react-router-dom'
import AdminPageLoad from '@core/providers/AdminPageLoad'
import managementRoutes from './management'
import ManagementLayout from '@components/templates/layouts/admin/ManagementLayout/ManagementLayout'
import withAuth from '@core/hocs/withAuth'
import withCompanyConfig from '@core/hocs/withCompanyConfig'
import { PersistentLayoutContext } from '@core/providers/PersistentLayoutContext'

const workspaceRoutes = managementRoutes.filter(({ path }) =>
  path.startsWith('/:companyGroup/self-service')
)

const Workspace = ({ route, ...props }) => {
  const Page = route.component
  return (
    <PersistentLayoutContext.Provider value={ManagementLayout}>
      <ManagementLayout {...props}>
        <AdminPageLoad
          key={route.path}
          form={/\/(add|edit|create)[-/]/.test(route.path)}
        >
          <Suspense fallback={null}>
            <Page {...props} routes={route.routes} />
          </Suspense>
        </AdminPageLoad>
      </ManagementLayout>
    </PersistentLayoutContext.Provider>
  )
}

const AuthenticatedWorkspace = withAuth({})(withCompanyConfig(Workspace))

const ManagementRouter = () => {
  const location = useLocation()
  // Preserve registry order and each route's existing exact/prefix matching.
  const route = managementRoutes.find((entry) =>
    matchPath(location.pathname, entry)
  )
  if (!route) return null

  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={(props) =>
        workspaceRoutes.includes(route) ? (
          <AuthenticatedWorkspace
            key={props.match.params.companyGroup}
            {...props}
            route={route}
          />
        ) : (
          <route.component {...props} routes={route.routes} />
        )
      }
    />
  )
}

export default ManagementRouter
